import React, { useEffect, useState } from 'react';
import {useHistory} from "react-router-dom";

import "../css/FoodMenu.css"
import axios from 'axios';

function FoodMenu() {
    var count = 0;
    const history = useHistory();
    const [images_for_elements_with_class_e_w_f_in, setImagesForElementsWithClassEWFIn] = useState([]); // Estado para almacenar las imagenes del la clase element-with-face-in
    const [categories_products, SetCategoriesProducts] = useState([]);

    const apiDomain = process.env.REACT_APP_DOMAIN_API;
    const withSSL = process.env.REACT_APP_SSL;

    const elements_for_food_menu = [
        'Para Empezar',
        'Entradas y ensaladas',
        'Pastas, risotos y sopas',
        'Carne, pescado y pollo',
        'Postres',
        'Destilados',
        'Bebidas',
        'Vinos',
        'V. Copeo'
    ];

    const get_list_objects = async() => {
    
        await axios.get(`http${withSSL}://${apiDomain}/api/no_auth/media_content/11/`).then(
            response => {
                const imagenes = response.data[0].imagenes.map(imagen => imagen.imagen);
                const nombres_imagenes = response.data[0].imagenes.map(imagen => imagen.nombre);

                setImagesForElementsWithClassEWFIn(imagenes);

                for(var i0 = 0; i0 < imagenes.length; i0++){
                    var item_with_class_element_with_face_in = document.getElementById(`fade-in-with-image-${i0+1}`);

                    var posicion = searchPositionForItemFoodMenu(elements_for_food_menu[i0], nombres_imagenes)

                    if(imagenes[posicion] !== null){
                        item_with_class_element_with_face_in.style.transition = 'all 200ms ease-in-out';
                        item_with_class_element_with_face_in.style.backgroundImage = `url(${imagenes[posicion]})`;
                        item_with_class_element_with_face_in.style.backgroundPosition = 'center';
                        item_with_class_element_with_face_in.style.backgroundRepeat = 'no-repeat';
                        item_with_class_element_with_face_in.style.backgroundSize = 'cover';
                    }
                }

                
            }
        ).catch(
            error => console.log(error)
        )
    }

    const get_list_categories_products = async() => {
    
        await axios.get(`http${withSSL}://${apiDomain}/api/no_auth/categories_products/`).then(
            response => {
                SetCategoriesProducts(response.data);
            }
        ).catch(
            error => console.log(error)
        )
    
    }

    function searchPositionForItemFoodMenu(search, images){
        var posicion = 0;
        
        for(var i0 = 0; i0 <= images.length; i0++){
            if(search == images[i0]){
                posicion = i0;
            }
        }

        return posicion
    }

    function hoverEffect(id, option){

        //console.log("option: "+option);
        //console.log("hover: "+id)

        let elementWithHoverEffect1;
        let elementWithHoverEffect2;

        console.log("id: ");
        console.log(id);
        document.getElementById("fade-in-food-"+id).style.flex = '2';

        let item_with_class_element_with_face_in = document.getElementById(`fade-in-with-image-${id}`);
        item_with_class_element_with_face_in.style.transform = 'scale(1.1)';

        if(option === 1){
            elementWithHoverEffect1 = document.getElementById(`container-link-${id}`);
            elementWithHoverEffect2 = document.getElementById(`child-line-${id}`);

            elementWithHoverEffect1.style.opacity = '1';
            elementWithHoverEffect1.style.transition = 'opacity 0.9s ease-in-out';
        }

        if(option === 2){
            elementWithHoverEffect2 = document.getElementById(`child-line-${id}`);
            elementWithHoverEffect2.style.width = '0%';
            elementWithHoverEffect2.style.transition = 'width 0.4s ease-in-out';
        }

        //aca se dedera agregar una opcion de que si esta el hover pueda cerrarse para hcer hover en otro lado ya que sino se tendra la vista de manera contante y nunca se quitara solo si se hace hover fuera del contnedor padre o se le puede poner un modo de viaje de izquierda a derecha
    }

    function noHoverEffect(id, option){
        //console.log("no option: "+option);
        //console.log("no hover: "+id)

        let elementWithHoverEffect1;
        let elementWithHoverEffect2;

        let elements_fade_in_food = document.getElementsByClassName("fade-in-food");

        for(var i0 = 0; i0 < elements_fade_in_food.length; i0++){
            let element_fade_in_food = elements_fade_in_food[i0];
            element_fade_in_food.style.flex = '1';
        }

        let item_with_class_element_with_face_in = document.getElementById(`fade-in-with-image-${id}`);
        item_with_class_element_with_face_in.style.transform = 'scale(1)';

        if(option === 1){
            elementWithHoverEffect1 = document.getElementById(`container-link-${id}`);

            elementWithHoverEffect1.style.opacity = '0';
            elementWithHoverEffect1.style.transition = 'opacity 0.9s ease-in-out';
        }

        if(option === 2){
            elementWithHoverEffect2 = document.getElementById(`child-line-${id}`);
            elementWithHoverEffect2.style.width = '50%';
            elementWithHoverEffect2.style.transition = 'width 0.4s ease-in-out';
        }
    }

    useEffect(() => {
        get_list_categories_products();
        console.log("useEffect");
    }, []); // El arreglo vacío [] asegura que el efecto se ejecute solo una vez

    useEffect(() => {
        if(categories_products.length > 0){
            console.log("categories_products: ");
            console.log(categories_products);
        }
    }, [categories_products]); // El arreglo vacío [] asegura que el efecto se ejecute solo una vez
    return (

        <div style={{display: "flex", flexDirection: "column"}}>
            <div className='container-food-menu'>
                {
                    categories_products.length > 0 ?
                    categories_products.map((category_product, index) => (
                        <article id={`fade-in-food-${category_product.id}`} className="fade-in-food" key={index}>
                            <section id={`element-with-face-in-${category_product.id}`} className="element-with-face-in" tabIndex={category_product.id} onMouseOver={() => hoverEffect(category_product.id, 1)} onMouseOut={()=> noHoverEffect(category_product.id, 1)}
                                style={{
                                    position: "relative",
                                }}
                                onClick={() => history.push(category_product.nombre.toLowerCase().includes("desti") ? '/item_6_in_food_menu' : category_product.nombre.toLowerCase().includes("vino") ? '/item_8_in_food_menu' : `/item_1_in_food_menu/${category_product.id}`)}
                                >
                                <div id={`fade-in-with-image-${category_product.id}`}
                                style={{
                                    position: "absolute",
                                    top: "0px",
                                    left: "0px",
                                    bottom: "0px",
                                    right: "0px",
                                    backgroundImage: `url(${category_product.imagen})`,
                                    backgroundPosition: "center",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "cover"
                                }}></div>
                                <div className="container-for-elements-with-face-in">
                                    <div id={`container-title-${category_product.id}`} className="container-title">
                                        <span className="child-title">{category_product.nombre}</span>
                                    </div>
                                    <div id={`container-link-${category_product.id}`} className="container-link" onMouseOver={() => hoverEffect(category_product.id, 2)} onMouseOut={()=> noHoverEffect(category_product.id, 2)}>
                                        <span className="child-link">Disfrútalos</span>
                                        <div id={`child-line-${category_product.id}`} className="child-line"></div>
                                    </div>
                                </div>
                            </section>
                        </article>
                    ))
                    :
                    <article className="fade-in-food">
                        <section className="element-with-face-in"
                            style={{
                                position: "relative",
                            }}
                            >
                            <div
                            style={{
                                position: "absolute",
                                top: "0px",
                                left: "0px",
                                bottom: "0px",
                                right: "0px"
                            }}></div>
                            <div className="container-for-elements-with-face-in">
                                <div className="container-title">
                                    <span className="child-title">Cargando ...</span>
                                </div>
                            </div>
                        </section>
                    </article>
                }
            </div>
        </div>
    )
}

export default FoodMenu
